import Laptop from "../../../../Images/laptop.png";
import "./Preview.css";

export default function Preview() {
  return (
    <div className="preview py-20">
      <div className="preview-container">
        <div className="sub-title text-center text-5xl md:text-7xl mb-10 mt-20">
          Preview of the projects
        </div>
        <div className="iframe-holder w-[60%] mx-auto lg:w-fit">
          <img src={Laptop} alt="" className="laptop-image" />
          <div className="bg-white w-full h-full absolute top-[4%] left-[50%] w-[77%] h-[80%] translate-x-[-50%] "></div>
          <div className="scaler">
            <iframe
              src="https://hnfdebrecen.com"
              title="project-preview-holder"
              className="project-iframe"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
